import React from "react";
import { connect } from "react-redux";
import { condicionesGralCarga } from "../mis-tramites/misTramites.act";
import gnpCondicionesGral from "./gnp-condiciones-gral.css"
import { servicios } from './../properties';

const mapState = (state) => {
	return {
		loading: state.global.loading,
		listado: state.tramites.condiciones_generales
	};
};

const mapDispatch = (dispatch) => {
	return {
		cargaCondicionesGral: () => {
			dispatch(condicionesGralCarga());
		}
	};
};

class GnpCondicionesGral extends React.Component {

	state = {
		ramo: "",
		subRamo: ""
	}

	componentWillMount = () => {
		this.props.cargaCondicionesGral();
	}

	changeRamo = (ev) => {
		this.setState({ ramo: ev.target.value });
	}

	componentDidMount(){
		const _body = document.getElementById("container");
		const _chageG = function() {
			const height = _body.offsetHeight + 50;
			window.parent.postMessage({frameHeight: height}, servicios.corporativo); //NOSONAR
		};
		new ResizeObserver(_chageG).observe(_body);
		new MutationObserver(_chageG).observe(_body, { attributes: true, childList: true, characterData: true });
}

	render() {
		return (
			<div className="gnp-condiciones-gral container" id="container">
				<p className="text-center">
					Si ya cuentas con la protección de un seguro (contratado con un Agente de Seguros, Individual o Familiar) te presentamos las condiciones generales que rigen tu contrato. Sólo debes seleccionar el ramo.
					<br /><br />
					Para mayor información acerca de nuestros productos comunícate a nuestro número único de Atención y Servicio a Clientes:
					<br /><br />
					<i>Línea GNP 55 5227 9000 </i><b>para la Ciudad de México e Interior de la República</b>
				</p>
				<div className="formulario">
					<div className="row">
						<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-xs-center text-sm-center text-md-right">
							Selecciona un ramo:
						</div>
						<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-xs-center text-sm-center text-md-left">
							<select name="ramo" className="selectPadding browser-default" onChange={this.changeRamo.bind(this)}>
								<option value="">Todos</option>
								<option value="gmm">Gastos Médicos Mayores (Individual)</option>
								<option value="gmm_grupo">Gastos Médicos Mayores (Colectivo)</option>
								<option value="vida">Vida (Individual)</option>
								<option value="vida_grupo">Vida (Grupo)</option>
								<option value="autos">Autos</option>
								<option value="danios">Daños</option>
							</select>
						</div>
					</div>
				</div>
				<div className="row mt-20">
					<div className="col-xs-12 text-center">
						<p></p>
					</div>
					<div className="col-xs-12 text-center">
						<ul className="listado">
							<li>
								<p>Resultado de la búsqueda</p>
							</li>
							{this.props.listado.map((item, i) => {

								if (this.state.ramo == "" || this.state.ramo == item.ramo) {
									let claves = [item.clave];
									if (item.clave.indexOf(" ")) {
										claves = item.clave.replace("/", "").split(" ");
									}
									return (
										<li key={i}>
											<a href={item.pdf} target="_blank" download className="layout-row layout-align-start-center layout-padding">
												<div className="flex-10 orange">pdf</div>
												<div className="flex-30">
													{claves.map((clave, k) => {
														return <span key={k}>{clave}<br /></span>;
													})}
												</div>
												<div className="flex-60">{item.descripcion}</div>
											</a>
										</li>
									);
								}
							})}
						</ul>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(GnpCondicionesGral);



// WEBPACK FOOTER //
// ./src/gnp-servicios-condiciones-gral/gnp-condiciones-gral.cmpt.js